<template>
    <div>
        <!-- Modal de relance -->
        <modal name="modal-add-code-connexion" height="auto" :scrollable="true" width="500px" :adaptive="true">
            <div class="p-6 text-center">
                <div class="mb-6">
                    <h2 class="text-xl font-bold text-gray-800">Connexion à {{ selectedTech?.prenom }} {{ selectedTech?.nom }}</h2>
                    <div>Un code de connexion vous a été envoyé par email</div>
                </div>

                <div v-if="!urlConnect">
                    <input v-model="codeConnexion" type="text" class="w-full px-4 py-2 border rounded-lg text-center text-xl font-mono tracking-wide bg-gray-100 focus:outline-none" placeholder="Code de connexion" />
                    <div class="flex justify-center mt-4 gap-4">
                        <button class="mt-4 px-4 py-2 bg-slate-200 hover:bg-slate-300 duration-200 text-gray-800 rounded-lg" @click="$modal.hide('modal-add-code-connexion')">
                            Annuler
                        </button>
                        <button :disabled="loadingConnect" @click="connect" class="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 duration-200 text-white rounded-lg">
                            <template v-if="loadingConnect">
                                <i class="fas fa-spinner fa-spin"></i> Connexion en cours...
                            </template>
                            <template v-else>
                                <i class="fas fa-unlock mr-1"></i> Dévérouiller
                            </template>
                        </button>
                    </div>
                </div>
                <div v-if="urlConnect">
                    <a :href="urlConnect" target="_blank" class="inline-block px-4 py-2 bg-green-600 hover:bg-green-700 duration-200 text-white rounded-lg">
                        <i class="fas fa-check mr-1"></i> Se connecter
                    </a>
                </div>
            </div>
        </modal>

        <!-- LOADER -->
        <div v-if="loadingList" class="flex justify-center py-12">
            <div class="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
        </div>

        <!-- LISTE -->
        <div v-if="!loadingList" class="bg-white shadow rounded-xl overflow-hidden">

            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nom</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Droits</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-gray-200">

                        <tr v-if="!techs.length">
                            <td colspan="4" class="px-6 py-6 text-center text-gray-500">
                                Aucun technicien
                            </td>
                        </tr>

                        <tr v-for="tech in techs" :key="tech.id" class="hover:bg-gray-50">

                            <td class="px-6 py-4">
                                <div class="font-medium">{{ tech.prenom }} {{ tech.nom }}</div>
                                <div class="text-xs font-light">{{ tech.email }}</div>
                            </td>

                            <td class="px-6 py-4 text-xs space-x-1">
                                <span v-if="tech.can_intervention" class="px-2 py-1 bg-blue-100 text-blue-700 rounded">Interv.</span>
                                <span v-if="tech.can_invoice" class="px-2 py-1 bg-red-100 text-red-700 rounded">Fact.</span>
                                <span v-if="tech.can_stats" class="px-2 py-1 bg-green-100 text-green-700 rounded">Stats</span>
                                <span v-if="tech.can_stock" class="px-2 py-1 bg-purple-100 text-purple-700 rounded">Stock</span>
                                <span v-if="tech.can_settings" class="px-2 py-1 bg-gray-200 text-gray-700 rounded">Settings</span>
                            </td>

                            <td class="px-6 py-4 space-x-2">
                                <button @click="askCodeConnexion(tech)" class="px-4 py-2 text-xs bg-purple-600 hover:bg-purple-700 duration-200 text-white rounded">
                                    <span v-if="loadingAskCode"><i class="fas fa-spinner fa-spin"></i></span>
                                    <span v-else><i class="fas fa-lock mr-1"></i> Demander un accès</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            societeId: this.$route.params.id,
            techs: [],

            selectedTech: null,
            codeConnexion: null,

            urlConnect: null,

            loadingList: false,
            loadingAskCode: false,
            loadingConnect: false,
        }
    },
    methods: {
        async loadTechs() {
            this.loadingList = true

            let res = await this.$request.post('/admin/societes/tech-list', {
                societe_id: this.societeId
            })

            this.techs = res

            this.loadingList = false
        },

        async askCodeConnexion(tech) {
            this.loadingAskCode = true
            await this.$request.post('/admin/societes/ask-code-connexion', {
                user_id: tech.id
            })
            this.loadingAskCode = false

            this.selectedTech = tech
            this.codeConnexion = null

            this.urlConnect = null

            this.$modal.show('modal-add-code-connexion')
        },

        async connect() {
            this.loadingConnect = true
            let response = await this.$request.post('/admin/societes/connect-tech', {
                user_id: this.selectedTech.id,
                code_connexion: this.codeConnexion
            })
            this.loadingConnect = false

            if (!response.success) {
                this.$toast.error(response.message || 'Code de connexion invalide')
                return
            }

            this.urlConnect = '/app/auth?token=' + response.token + '&session=1'
        },
    },
    mounted () {
        this.loadTechs()
    },
}
</script>

<style lang="scss" scoped>

</style>